import _ from 'lodash';
import template from './tankPanel.html';

export default {
  name: 'tankPanel',
  template,
  controller: TankPanelController,
  bindings: {
    panelId: '<'
  }
};

/* @ngInject */
function TankPanelController($scope, TankPanelService, DashboardService) {
  const vm = this;

  // public variables
  vm.loadingSpinners = {};
  vm.headerModel = {};
  vm.editPanel = {
    needsToBeConfigured: false
  };
  vm.activeEquipment = {};
  vm.activeEquipmentId = 'Summary';
  vm.oilHover = false;
  vm.waterHover = false;

  // public functions
  vm.$onInit = init;
  vm.$postLink = postLink;
  vm.$onDestroy = destroy;
  vm.setActiveEquipment = setActiveEquipment;
  vm.updateTankValuesFromEvent = updateTankValuesFromEvent;
  vm.updateReportDataObj = updateReportDataObj;
  vm.newReportData = newReportData;
  vm.highlightTheField = highlightTheField;


  function init() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    if (vm.panel.equipment && vm.panel.equipment.length) {
      // panel is good to go
      vm.loadingSpinners.stopTankPanel = false;
      vm.editPanel.needsToBeConfigured = false;
      vm.equipment = TankPanelService.createModel(vm.panel.id);
      TankPanelService.getEquipmentFromIds(vm.panel.id, vm.panel.equipment)
        .then((equipment) => {
          const newHeaderModel = {};
          _.forEach(equipment, (eq) => {
            newHeaderModel[eq.id] = eq;
            TankPanelService.getSummaryData(vm.panel.id, eq.id)
              .then(() => {
                vm.loadingSpinners.stopTankPanel = true;
              })
              .catch(() => {
                vm.loadingSpinners.stopTankPanel = true;
              });
          });
          vm.headerModel = newHeaderModel;
          vm.setActiveEquipment(_.values(vm.headerModel)[0]);
        });
    } else {
      // panel needs to be configured
      vm.loadingSpinners.stopTankPanel = true;
      vm.editPanel.needsToBeConfigured = true;
    }
  }

  function postLink() {
    setupEventListeners(vm.panel.equipment);
  }

  function destroy() {
    TankPanelService.destroy(vm.panel.id);
  }

  function setActiveEquipment(eq) {
    vm.activeEquipment = vm.equipment[eq.id];
    vm.activeEquipmentId = eq.id;
  }

  function updateTankValuesFromEvent(eventObj) {
    TankPanelService.updateTankValuesFromEvent(vm.panel.id, eventObj);
  }

  function updateReportDataObj(reportObj) {
    TankPanelService.updateReportDataObj(vm.panel.id, reportObj);
  }

  function newReportData(reportArray) {
    TankPanelService.newReportData(vm.panel.id, reportArray);
  }

  function highlightTheField(field) {
    vm[field] = !vm[field];
  }

  function setupEventListeners(equipment) {
    _.forEach(equipment, (equipmentId) => {
      $scope.$on(`event:${equipmentId}`, (__, eventObj) => {
        vm.updateTankValuesFromEvent(eventObj);
      });
      $scope.$on(`report:${equipmentId}`, (__, reportArray) => {
        vm.newReportData(reportArray);
      });
    });
    $scope.$on('report:updated', (__, reportObj) => {
      vm.updateReportDataObj(reportObj);
    });
  }
}
